import * as sx from "./square.sx";

export const { square } = sx;

export const SQUARE_ASPECT_RATIO: React.CSSProperties = { aspectRatio: "1" };

export function Square({
  className,
  ref,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) {
  return (
    /* the first div limits width, but tall viewports can still have excess height */
    <sx.Square className={className}>
      {/* the second div limits height; I don't understand why, but it works */}
      {/**
       * the extra height:100% is necessary for Safari
       * [SPT-2207](https://github.com/CitrineInformatics/triton-ui/pull/4391)
       */}
      <sx.Square {...props} ref={ref} sx={{ height: "100%" }} />
    </sx.Square>
  );
}
